<template>
  <modal>
    <div class="modal-header">
      <h4 class="title">เพิ่มซีซันใหม่</h4>
      <button
        @click.stop="onClose"
        type="button"
        class="btn btn-link btm-sm btn-close-container">
        <i class="fas fa-times"></i>
      </button>
    </div>
    <div class="modal-body">
      <FormGroup class="mb-0">
        <h5 class="name">เพิ่มซีซันใหม่ของรายการ <strong>{{getProgramName()}}</strong></h5>

        <div class="row mt-3 mb-3">
          <div class="col-md-4">
            <h5 class="name">หมายเลขซีซั่น</h5>
            <input
              type="text"
              :class="{'is-invalid': isSameSeasonNumber}"
              placeholder="หมายเลขซีซั่น"
              onkeypress="return event.charCode>=48 && event.charCode<=57"
              class="form-control"
              v-model="seasonNo"/>
            <div
              class="invalid-feedback"
              v-if="isSameSeasonNumber">หมายเลขซีซั่นซ้ำ กรุณากรอกหมายเลขซีซั่นใหม่</div>
          </div>
          <div class="col-md-8">
            <h5 class="name">ชื่อซีซัน</h5>
            <input
              type="text"
              placeholder="ชื่อซีซัน"
              class="form-control"
              v-model="seasonTitle"/>
          </div>
        </div>

        <h5 class="name mt-2">ระบบจะคัดลอกรายละเอียดซีซันล่าสุดมาเป็นรายละเอียดของซีซันนี้ และเผยแพร่ซีซันแรกนี้โดยอัตโนมัติ</h5>
        <br/>
        <h5 class="name">โปรดทราบว่าเมื่อเริ่มสร้างซีซันแล้ว รายการจะเปลี่ยนประเภทเป็นรายการที่ออกอากาศเป็นซีซัน ซึ่งมีความแตกต่างจากรายการที่ออกอากาศต่อเนื่อง ดังนี้</h5>
        <ul>
          <li><h5 class="name">ท่านจะแก้ไขรายละเอียดรายการได้เฉพาะข้อมูลเบื้องต้นเท่านั้น รายละเอียดอื่นๆ จะถูกอัพเดทอัตโนมัติตามซีซันล่าสุด</h5></li>
          <li><h5 class="name">เว็บของรายการ จะเปลี่ยนเป็นเว็บของซีซันล่าสุดที่เผยแพร่</h5></li>
          <li><h5 class="name">ตอน วิดีโอ และเพลย์ลิสต์ที่มีอยู่ในปัจจุบัน จะถูกย้ายไปเป็นเนื้อหาของ <strong>{{getProgramName()}}</strong> โดยอัตโนมัติ</h5></li>
          <li><h5 class="name">ตอน วิดีโอ และเพลย์ลิสต์ที่จะสร้างใหม่ในอนาคตของรายการนี้ จะต้องระบุซีซันเสมอ</h5></li>
        </ul>
      </FormGroup>
    </div>
    <div class="modal-footer">
        <button
          class="btn btn-primary"
          type="button"
          @click="onSubmit"
          :disabled="!isValid || isSameSeasonNumber">
          <i class="fa fa-spinner fa-spin mr-1" v-if="isSaving" />สร้างซีซันใหม่
        </button>
    </div>
  </modal>
</template>

<script>
import _ from 'lodash';
import { mapState } from 'vuex';
import Modal from '@/components/Modal.vue';
import FormGroup from '@/components/FormGroup.vue';
import { createSeason } from './api';

export default {
  components: {
    Modal,
    FormGroup,
  },
  props: {
    onClose: {
      type: Function,
      default: () => {},
    },
    goToFirstTab: {
      type: Function,
      default: () => {},
    },
  },
  data() {
    return {
      seasonNo: '',
      seasonTitle: '',
      isSaving: false,
    };
  },
  computed: {
    ...mapState({
      currentProgram: (state) => state.programItem.currentProgram,
      seasons: (state) => state.programItem.seasons,
    }),
    isValid() {
      if (this.seasonNo && this.seasonTitle) {
        return true;
      }
      return false;
    },
    isSameSeasonNumber() {
      const isSameNo = !!this.seasons.find((season) => season.seasonNumber === parseInt(this.seasonNo, 10));
      if (this.seasonNo && isSameNo) return true;
      return false;
    },
  },
  methods: {
    async onSubmit() {
      const newSeason = {
        title: this.seasonTitle,
        seasonNumber: this.seasonNo,
      };
      if (this.currentProgram.programType === 'program') {
        await createSeason(this.currentProgram.id, newSeason);
      } else if (this.currentProgram.programType === 'season') {
        await createSeason(this.currentProgram.parentProgramId, newSeason);
      }
      await this.$store.dispatch('loadProgramByKey', this.currentProgram.id);
      this.onClose();
      // this.goToFirstTab();
    },
    getProgramName() {
      return _.get(this.currentProgram, 'title', this.programKey);
    },
  },
};
</script>

<style lang="scss" scoped>

</style>
